import { Splitter } from "@progress/kendo-react-layout";
import React from "react";

export const onChange = (event, setPanes) => {
  if (event.newState[0].collapsed) {
    event.newState[1].collapsible = false;
    event.newState[1].size = undefined;
  } else {
    event.newState[1].collapsible = true;
  }
  if (event.newState[1].collapsed) {
    event.newState[0].collapsible = false;
  } else {
    event.newState[0].collapsible = true;
  }
  setPanes(event.newState);
};

const CustomSplitter = (props) => {
    const { size='30' , orientation = "horizontal" , lMin = "20" , rMin = "40" , style = { height:"100vh" , width:"100%" } } = props;
    const [panes, setPanes] = React.useState([
        {
            size: `${size}%`,
            min: `${lMin}%`,
            collapsible: true,
            scrollable: false,
        },
        {
            min: `${rMin}%`,
            collapsible: true,
            scrollable: false,
        },
    ]);
    return (
        <>
                <Splitter
                    panes={panes}
                    orientation={orientation}
                    onChange={(event) => onChange(event, setPanes)}
                    scrollable={false}
                    style={style}
                >
                    {props.children}
                </Splitter>
        </>
    )
}

export default CustomSplitter
